// Favoris
document.addEventListener("click", (e) => {
  const save = e.target.closest(".product__save");
  if (save) {
    e.preventDefault();
    const on = save.classList.toggle("is-saved");
    save.setAttribute("aria-pressed", on);
  }
});

// Panier : ajout sans quitter la page (API AJAX Shopify)
const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
const fmtMoney = (cents) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(cents / 100);

function setCartCount(n) {
  document.querySelectorAll(".cart-count").forEach((el) => (el.textContent = n));
}

let toastTimer;
function toast(html) {
  let el = document.querySelector(".toast");
  if (!el) {
    el = document.createElement("div");
    el.className = "toast";
    el.setAttribute("role", "status");
    document.body.appendChild(el);
  }
  el.innerHTML = html;
  el.classList.add("is-on");
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => el.classList.remove("is-on"), 4000);
}

async function addToCart(items) {
  const res = await fetch(ROOT + "cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ items }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.description || data.message || "Erreur");
  const cart = await (await fetch(ROOT + "cart.js")).json();
  setCartCount(cart.item_count);
  return cart;
}

async function handleAdd(button, items, then) {
  const label = button.textContent;
  button.disabled = true;
  button.textContent = "Ajout…";
  try {
    const cart = await addToCart(items);
    if (then) return then();
    button.textContent = label;
    button.disabled = false;
    openDrawer(cart);
  } catch (err) {
    toast(err.message);
    button.textContent = label;
  }
  setTimeout(() => { button.disabled = false; button.textContent = label; }, 1800);
}

// Ajout rapide depuis les cartes produit
document.addEventListener("click", (e) => {
  const btn = e.target.closest(".product__add[data-variant-id]");
  if (!btn) return;
  e.preventDefault();
  handleAdd(btn, [{ id: Number(btn.dataset.variantId), quantity: 1 }]);
});

// Boutons +/- de quantité
document.addEventListener("click", (e) => {
  const b = e.target.closest("[data-qty]");
  if (!b) return;
  const input = b.parentElement.querySelector("input");
  input.value = Math.max(Number(input.min || 0), Number(input.value || 0) + Number(b.dataset.qty));
  input.dispatchEvent(new Event("change", { bubbles: true }));
});

// Panier : la quantité modifiée est enregistrée tout de suite
let cartTimer;
document.addEventListener("change", (e) => {
  const input = e.target.closest("[data-auto-update]");
  if (!input) return;
  clearTimeout(cartTimer);
  cartTimer = setTimeout(async () => {
    input.closest(".cart__item").style.opacity = ".5";
    await fetch(ROOT + "cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line: Number(input.dataset.line), quantity: Math.max(0, Number(input.value) || 0) }),
    });
    location.reload();
  }, 350);
});

// Page produit : packs, ajout au panier, achat immédiat
document.querySelectorAll("[data-product-form]").forEach((form) => {
  const price = document.querySelector("[data-price]");
  const addBtn = form.querySelector(".pdp__add");
  const upsell = form.querySelector("[data-upsell]");
  const payload = () => {
    const items = [{
      id: Number(new FormData(form).get("id")),
      quantity: Number(form.querySelector('[name="quantity"]').value || 1),
    }];
    // case « Complète ta routine » cochée : on ajoute aussi la Recharge
    if (upsell && upsell.checked) items.push({ id: Number(upsell.value), quantity: 1 });
    return items;
  };
  const stickyPrice = document.querySelector("[data-sticky-price]");
  form.addEventListener("change", (e) => {
    if (e.target.name !== "id") return;
    price.textContent = e.target.dataset.price;
    const vname = document.querySelector("[data-variant-name]");
    if (vname && e.target.dataset.label) vname.textContent = " · " + e.target.dataset.label;
    if (stickyPrice) stickyPrice.textContent = e.target.dataset.price;
    const url = new URL(location.href);
    url.searchParams.set("variant", e.target.value);
    history.replaceState(null, "", url);
  });
  form.addEventListener("submit", (e) => {
    e.preventDefault();
    handleAdd(addBtn, payload());
  });
  form.querySelector("[data-buy-now]").addEventListener("click", (e) =>
    handleAdd(e.currentTarget, payload(), () => (location.href = ROOT + "checkout"))
  );
});

// Carrousel
document.querySelectorAll(".carousel").forEach((c) => {
  const track = c.querySelector(".carousel__track");
  const prev = c.querySelector(".carousel__arrow--prev");
  const next = c.querySelector(".carousel__arrow--next");
  const step = () => track.querySelector(".product").getBoundingClientRect().width + 16;
  const update = () => {
    prev.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
  };
  prev.addEventListener("click", () => track.scrollBy({ left: -step(), behavior: "smooth" }));
  next.addEventListener("click", () => track.scrollBy({ left: step(), behavior: "smooth" }));
  track.addEventListener("scroll", update, { passive: true });
  window.addEventListener("resize", update);
  update();
});

// Défilement fluide (Lenis) synchronisé avec GSAP ScrollTrigger
gsap.registerPlugin(ScrollTrigger);
const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
const lenis = new Lenis({
  duration: 1.2,
  easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
  smoothWheel: !reduceMotion,
});
lenis.on("scroll", ScrollTrigger.update);
gsap.ticker.add((t) => lenis.raf(t * 1000));
gsap.ticker.lagSmoothing(0);

// Ancres internes via Lenis (décalage = hauteur de l'en-tête collant)
document.querySelectorAll('a[href^="#"]').forEach((a) => {
  a.addEventListener("click", (e) => {
    const id = a.getAttribute("href");
    if (id.length < 2) return;
    const target = document.querySelector(id);
    if (!target) return;
    e.preventDefault();
    lenis.scrollTo(target, { offset: -document.querySelector(".header").offsetHeight, force: true });
  });
});

const scrolly = document.getElementById("scrolly");
if (scrolly) {
// Hero scroll : 193 images extraites de video/orbit.mp4, hébergées dans Fichiers Shopify
const FRAME_COUNT = 193;
const FRAME_END = 0.86; // la vidéo se termine à 86 % de la section, puis on tient la vue éclatée
const FRAMES_BASE = window.SATILAME_FRAMES_BASE || "frames/";
const framePath = (i) => `${FRAMES_BASE}frame_${String(i + 1).padStart(4, "0")}.webp`;

const canvas = document.getElementById("canvas");
const ctx = canvas.getContext("2d");
const frames = new Array(FRAME_COUNT);
let currentFrame = 0;
let loaded = 0;

function drawFrame(index) {
  const img = frames[index];
  if (!img || !img.complete || !img.naturalWidth) return;
  const cw = canvas.width, ch = canvas.height;
  const iw = img.naturalWidth, ih = img.naturalHeight;
  const contain = Math.min(cw / iw, ch / ih);
  const cover = Math.max(cw / iw, ch / ih);
  // Paysage : tout le cadre visible. Portrait : on zoome sur le rasoir (~55 % central).
  const scale = cw >= ch ? contain : Math.min(cover, cw / (iw * 0.55));
  const dw = iw * scale, dh = ih * scale;
  ctx.fillStyle = "#fff";
  ctx.fillRect(0, 0, cw, ch);
  ctx.filter = "brightness(1.04) contrast(1.06)";
  // En portrait, on remonte le rasoir pour laisser la place au texte en bas
  const dy = (ch - dh) / 2 - (cw < ch ? ch * 0.1 : 0);
  ctx.drawImage(img, (cw - dw) / 2, dy, dw, dh);
  ctx.filter = "none";
}

function resizeCanvas() {
  const dpr = Math.min(window.devicePixelRatio || 1, 2);
  const r = canvas.getBoundingClientRect();
  canvas.width = Math.round(r.width * dpr);
  canvas.height = Math.round(r.height * dpr);
  drawFrame(currentFrame);
}

function onFrameLoad() {
  loaded++;
  const pct = Math.round((loaded / FRAME_COUNT) * 100);
  document.getElementById("loader-bar").style.width = pct + "%";
  document.getElementById("loader-pct").textContent = pct + " %";
  if (loaded === FRAME_COUNT) scrolly.classList.add("is-ready");
}

function loadFrame(i) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = img.onerror = () => { onFrameLoad(); resolve(); };
    img.src = framePath(i);
    frames[i] = img;
  });
}

// Préchargement en deux temps : les 10 premières images, puis le reste en parallèle
(async () => {
  await Promise.all(Array.from({ length: 10 }, (_, i) => loadFrame(i)));
  resizeCanvas();
  for (let i = 10; i < FRAME_COUNT; i++) loadFrame(i).then(() => { if (i === currentFrame) drawFrame(i); });
})();
window.addEventListener("resize", resizeCanvas);

// Image courante pilotée par le défilement
ScrollTrigger.create({
  trigger: scrolly,
  start: "top top",
  end: "bottom bottom",
  scrub: true,
  onUpdate: (self) => {
    const p = self.progress;
    const index = Math.min(Math.floor(Math.min(p / FRAME_END, 1) * FRAME_COUNT), FRAME_COUNT - 1);
    if (index !== currentFrame) {
      currentFrame = index;
      requestAnimationFrame(() => drawFrame(index));
    }
    document.getElementById("progress-bar").style.width = (p * 100).toFixed(2) + "%";
  },
});

// Textes : chacun apparaît dans sa fenêtre de défilement, avec une entrée différente
const ENTRANCES = {
  intro: { from: { y: 0, opacity: 1 } },
  left: { from: { x: -60, opacity: 0 } },
  right: { from: { x: 60, opacity: 0 } },
  outro: { from: { y: 50, opacity: 0 } },
};
document.querySelectorAll(".beat").forEach((beat) => {
  const show = parseFloat(beat.dataset.show);
  const hide = parseFloat(beat.dataset.hide);
  const kind = [...beat.classList].find((c) => c.startsWith("beat--")).slice(6);
  const kids = beat.children;
  const tl = gsap.timeline({ paused: true })
    .set(beat, { autoAlpha: 1 })
    .from(kids, { ...ENTRANCES[kind].from, duration: 0.9, ease: "power3.out", stagger: 0.12 });
  if (kind === "intro") {
    // l'intro est visible au chargement : mots en cascade, puis fondu au défilement
    gsap.set(beat, { autoAlpha: 1 });
    gsap.from(beat.querySelectorAll(".word"), { y: 40, opacity: 0, duration: 1, ease: "power3.out", stagger: 0.12, delay: 0.2 });
  }
  let visible = kind === "intro";
  ScrollTrigger.create({
    trigger: scrolly,
    start: "top top",
    end: "bottom bottom",
    onUpdate: (self) => {
      const p = self.progress;
      if (kind === "intro") {
        gsap.set(beat, { autoAlpha: Math.max(0, 1 - p / hide) });
        return;
      }
      const inside = p >= show && p < hide;
      if (inside && !visible) { visible = true; tl.timeScale(1).play(0); }
      else if (!inside && visible) { visible = false; tl.timeScale(2).reverse(); }
    },
  });
});

}

// Menu mobile
const burger = document.querySelector(".burger");
const menu = document.querySelector(".mobile-menu");
burger.addEventListener("click", () => {
  const open = burger.getAttribute("aria-expanded") === "true";
  burger.setAttribute("aria-expanded", !open);
  menu.hidden = open;
  open ? lenis.start() : lenis.stop();
});
menu.querySelectorAll("a").forEach((a) =>
  a.addEventListener("click", () => {
    burger.setAttribute("aria-expanded", "false");
    menu.hidden = true;
    lenis.start();
  })
);

// Bouton « remonter » en bas de la page produit
document.querySelectorAll("[data-scroll-top]").forEach((a) =>
  a.addEventListener("click", (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: "smooth" });
  })
);

// Barre d'achat collée en bas (mobile) : visible quand le bouton principal sort de l'écran
(() => {
  const bar = document.querySelector("[data-sticky-buy]");
  const main = document.querySelector(".pdp__add");
  const form = document.querySelector("[data-product-form]");
  if (!bar || !main || !form) return;
  bar.hidden = false;
  // visible dès que le bouton principal est passé au-dessus de l'écran
  const update = () => bar.classList.toggle("is-on", main.getBoundingClientRect().bottom < 0);
  window.addEventListener("scroll", update, { passive: true });
  update();
  bar.querySelector("[data-sticky-add]").addEventListener("click", () => main.click());
})();

// Bandeau : les messages défilent
(() => {
  const msgs = document.querySelectorAll("[data-announce] .announce__msg");
  if (msgs.length < 2) return;
  let i = 0;
  setInterval(() => {
    msgs[i].classList.remove("is-on");
    i = (i + 1) % msgs.length;
    msgs[i].classList.add("is-on");
  }, 3500);
})();

// Panier latéral : s'ouvre après un ajout (et au clic sur l'icône panier)
const FREE_SHIP = 5000; // livraison offerte dès 50 €
let drawer;
function buildDrawer() {
  drawer = document.createElement("div");
  drawer.className = "drawer";
  drawer.hidden = true;
  drawer.innerHTML = `
    <div class="drawer__backdrop" data-close></div>
    <aside class="drawer__panel" role="dialog" aria-modal="true" aria-label="Votre panier">
      <div class="drawer__head"><p>Votre panier</p><button type="button" class="drawer__x" data-close aria-label="Fermer">×</button></div>
      <div class="drawer__ship"></div>
      <div class="drawer__items"></div>
      <div class="drawer__foot">
        <div class="drawer__discount"></div>
        <div class="drawer__total"><span>Total</span><strong></strong></div>
        <a class="btn drawer__pay" href="${ROOT}checkout">Paiement sécurisé →</a>
        <a class="drawer__cart" href="${ROOT}cart">Voir le panier</a>
      </div>
    </aside>`;
  document.body.appendChild(drawer);
  drawer.addEventListener("click", async (e) => {
    if (e.target.closest("[data-close]")) return closeDrawer();
    const q = e.target.closest("[data-dkey]");
    if (q) {
      const res = await fetch(ROOT + "cart/change.js", {
        method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: q.dataset.dkey, quantity: Number(q.dataset.dqty) }),
      });
      const cart = await res.json();
      setCartCount(cart.item_count);
      renderDrawer(cart);
    }
  });
  document.addEventListener("keydown", (e) => { if (e.key === "Escape" && drawer && !drawer.hidden) closeDrawer(); });
}
function renderDrawer(cart) {
  const left = FREE_SHIP - cart.total_price;
  const pct = Math.min(100, Math.round((cart.total_price / FREE_SHIP) * 100));
  drawer.querySelector(".drawer__ship").innerHTML = cart.item_count === 0 ? "" :
    `<p>${left > 0 ? `Plus que <strong>${fmtMoney(left)}</strong> pour la livraison offerte` : "<strong>Livraison offerte</strong> ✓"}</p>
     <span class="drawer__bar"><span style="width:${pct}%"></span></span>`;
  drawer.querySelector(".drawer__items").innerHTML = cart.items.length === 0
    ? `<p class="drawer__empty">Votre panier est vide.</p>`
    : cart.items.map((it) => `
      <div class="drawer__item">
        ${it.image ? `<img src="${it.image.replace(/(\.[a-z]+)(\?|$)/i, "_160x$1$2")}" alt="" width="64" height="64">` : ""}
        <div class="drawer__info">
          <p class="drawer__title">${it.product_title}</p>
          ${it.variant_title ? `<p class="drawer__variant">${it.variant_title}</p>` : ""}
          <div class="drawer__qty">
            <button type="button" data-dkey="${it.key}" data-dqty="${it.quantity - 1}" aria-label="Diminuer">−</button>
            <span>${it.quantity}</span>
            <button type="button" data-dkey="${it.key}" data-dqty="${it.quantity + 1}" aria-label="Augmenter">+</button>
          </div>
        </div>
        <p class="drawer__price">${fmtMoney(it.final_line_price)}</p>
      </div>`).join("");
  const codes = (cart.cart_level_discount_applications || []).map((d) => `${d.title} : -${fmtMoney(d.total_allocated_amount)}`);
  drawer.querySelector(".drawer__discount").innerHTML = codes.length ? `<p>Code ${codes.join(", ")}</p>` : "";
  drawer.querySelector(".drawer__total strong").textContent = fmtMoney(cart.total_price);
  drawer.querySelector(".drawer__foot").hidden = cart.item_count === 0;
}
function openDrawer(cart) {
  if (!drawer) buildDrawer();
  renderDrawer(cart);
  drawer.hidden = false;
  requestAnimationFrame(() => drawer.classList.add("is-open"));
  document.documentElement.style.overflow = "hidden";
}
function closeDrawer() {
  drawer.classList.remove("is-open");
  document.documentElement.style.overflow = "";
  setTimeout(() => (drawer.hidden = true), 250);
}
document.querySelectorAll("a.icon-btn.cart").forEach((a) =>
  a.addEventListener("click", async (e) => {
    e.preventDefault();
    openDrawer(await (await fetch(ROOT + "cart.js")).json());
  })
);
